'use client'

import { useEffect } from 'react'
import { getRootBodyStyle } from 'app/lib/rootLayoutUtils'
import { generateThemeStyles } from 'app/lib/generateThemeStyles'

/**
 * Syncs html lang/dir and body style/class from [lang] layout.
 * Root layout is minimal (no headers), so [lang] provides lang and config;
 * this component applies them to the document after mount.
 */
export function ShellSync({
    lang,
    config
}: {
    lang: string
    config: IDomainConfig | null
}) {
    useEffect(() => {
        document.documentElement.lang = lang
        document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr'

        const bodyStyle = getRootBodyStyle(config)
        Object.assign(document.body.style, bodyStyle)

        const { dataTheme, enableNoiseTexture } = generateThemeStyles(config)
        if (dataTheme) document.documentElement.setAttribute('data-theme', dataTheme)
        document.body.classList.toggle('bg-noise-texture', !!enableNoiseTexture)
    }, [lang, config])

    return null
}
